import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  CityFilterAction,
  buildingFilterAction,
  editTrainingRoomForm,
  RoomMaList,
  FloorFilterAction,
} from '../../Redux/action/roomTraingAction';

import Select from 'react-select';
import { dataUser } from '../Helpers/util';

var QRCode = require('qrcode.react');

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class QRCodeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataAdd: false,
      company_id: '202',
      baseUrlCommon:
        'https://smartworks-web-production.s3-ap-southeast-1.amazonaws.com/mrcr_room_images_thumb/',
      itemsEdit: {},
      SetRoomStatus: '',
      RoomUpperPannel: [],
      RoomTrainingList: [],
      FloorApiData: [],
      qrUrls: 0,
      seat: '',
      setFlagCity: false,
      cityApiData: [],
      buildingApiData: [],

      meetingroom_code: '',
      city: '',
      room_image: null,
      building_id: '',
      floor_id: '',
      room_type: '',
      status: '',
      no_of_seats: '',
      time_slot: '',
      price_per_slot: '',
      meeting_alltime: '',
      meeting_opentime: '',
      meeting_closetime: '',
    };
  }

  EditSubmit = e => {
    e.preventDefault();

    if (this.state.meetingroom_code == '') {
      toast.configure();
      toast.success('Please Enter Room Name', {
        
      });
    } else {
      // const formData = new FormData();
      // formData.append("meetingroom_code", this.state.meetingroom_code);
      // formData.append("company_id", this.state.company_id);
      // formData.append("token", 'U21hcnR3b3Jrcy1GZWVkYmFjay1BUEktVjEtMjAxOQ==' );
      // if (this.state.room_image != "") {
      //   formData.append("room_image", this.state.room_image);
      // }
      // formData.append("meetingroom_id", this.state.meetingroom_id);
      // formData.append("floor_id", this.state.floor_id );
      // formData.append("room_type", this.state.room_type);
      // formData.append("status", this.state.status);
      // formData.append("no_of_seats", this.state.no_of_seats);
      // formData.append("time_slot", this.state.time_slot);
      // formData.append("price_per_slot", this.state.price_per_slot);
      // formData.append("meeting_alltime", this.state.meeting_alltime);
      // formData.append("meeting_opentime", this.state.meeting_opentime);
      // formData.append("meeting_closetime", this.state.meeting_closetime)
      let param = {
        meetingroom_code: this.state.meetingroom_code,
        room_image: this.state.room_image,
        meetingroom_id: this.state.meetingroom_id,
        company_id: this.state.company_id,
        floor_id: this.state.floor_id,
        room_type: this.state.room_type,
        status: this.state.status,
        no_of_seats: this.state.no_of_seats,
        time_slot: this.state.time_slot,
        price_per_slot: this.state.price_per_slot,
        meeting_alltime: this.state.meeting_alltime,
        meeting_opentime: this.state.meeting_opentime,
        meeting_closetime: this.state.meeting_closetime,
        // token: 'U21hcnR3b3Jrcy1GZWVkYmFjay1BUEktVjEtMjAxOQ==',
      };

      this.props.editTrainingRoomForm(param);
      this.setState({
        dataAdd: true,
      });
    }
  };

  onChangeValue = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  EditMemeberHandler = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  uploadImg = async event => {
    let convertBase64 = '';
    const fileReader = new FileReader();
    fileReader.readAsDataURL(event.target.files[0]);
    fileReader.onload = () => {
      convertBase64 = fileReader.result;
      this.setState({
        room_image: convertBase64,
        nfile: URL.createObjectURL(event.target.files[0]),
      });
    };
  };

  convertBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = error => {
        reject(error);
      };
    });
  };

  //   imgUrl = (qrCode) => {
  //     let setQurImg = this.state.ImgUrl + qrCode;
  //     this.setState({
  //       setAll: setQurImg,
  //     });
  //   };

  qrCodeUrl = (qrUrl, setaNum) => {
    let setQr = qrUrl;
    this.setState({
      qrUrls: setQr,
      seat: setaNum,
    });
  };

  downloadQR = () => {
    const canvas = document.getElementById('123456');
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');
    let downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'QR.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  componentDidMount() {
    // this.SetCityValue();
  }

  render() {
    return (
      <>
        <div id="QR" className="col-md-12 col-xl-6 col-lg-6">
     
          <QRCode
            id="123456"
            value={this.props.meetingId}
            size={200}
            level={'H'}
            includeMargin={true}
          />
        </div>
      </>
    );
  }
}

export default QRCodeComponent;
